import { render, staticRenderFns } from "./MoreStockLabelOrderDialog.vue?vue&type=template&id=71bd2264&scoped=true&"
import script from "./MoreStockLabelOrderDialog.vue?vue&type=script&lang=js&"
export * from "./MoreStockLabelOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreStockLabelOrderDialog.vue?vue&type=style&index=0&id=71bd2264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd2264",
  null
  
)

export default component.exports